import {
    IconArmchair,
    IconArrowDown,
    IconArrowLeft,
    IconArrowRight,
    IconArrowsLeftRight,
    IconBatteryCharging,
    IconBuildings,
    IconCalendar,
    IconCar,
    IconCaretLeft,
    IconCaretRight,
    IconCheck,
    IconChevronDown,
    IconClipboardText,
    IconClock,
    IconDrop,
    IconEngine,
    IconEnvelope,
    IconFacebook,
    IconGauge,
    IconGearSix,
    IconGithub,
    IconGraduationCap,
    IconHandCoins,
    IconHandshake,
    IconHeadset,
    IconInstagram,
    IconKey,
    IconLightning,
    IconLinkedin,
    IconListChecks,
    IconMapPin,
    IconMapTrifold,
    IconMastodon,
    IconMenu,
    IconPackage,
    IconPaperPlane,
    IconPercent,
    IconPhone,
    IconPhoneCall,
    IconPinterest,
    IconPlus,
    IconSealCheck,
    IconShieldCheck,
    IconSnowflake,
    IconSparkle,
    IconSteeringWheel,
    IconStorefront,
    IconSun,
    IconTag,
    IconTelegram,
    IconTiktok,
    IconTire,
    IconUsersThree,
    IconWarningCircle,
    IconWhatsapp,
    IconWrench,
    IconX,
    IconXMark,
    IconYoutube,
} from '@/components/icons';

/**
 * Registry for UiIcon: maps a stored icon key (kebab-case) to its component.
 * Social keys mirror the Studio picker (studio/constants/iconOptions.ts →
 * SOCIAL_ICON_OPTIONS), content keys mirror CONTENT_ICON_OPTIONS. An unknown
 * key renders nothing (see UiIcon).
 */
export const ICONS = {
    // UI / navigational icons (used statically in the app)
    'arrow-down': IconArrowDown,
    'chevron-down': IconChevronDown,
    'arrow-left': IconArrowLeft,
    'arrow-right': IconArrowRight,
    'arrows-left-right': IconArrowsLeftRight,
    'caret-left': IconCaretLeft,
    'caret-right': IconCaretRight,
    check: IconCheck,
    menu: IconMenu,
    plus: IconPlus,
    'x-mark': IconXMark,

    // Content icons (CONTENT_ICON_OPTIONS) — Phosphor regular
    armchair: IconArmchair,
    'battery-charging': IconBatteryCharging,
    buildings: IconBuildings,
    calendar: IconCalendar,
    car: IconCar,
    'clipboard-text': IconClipboardText,
    clock: IconClock,
    drop: IconDrop,
    engine: IconEngine,
    envelope: IconEnvelope,
    gauge: IconGauge,
    'gear-six': IconGearSix,
    'graduation-cap': IconGraduationCap,
    'hand-coins': IconHandCoins,
    handshake: IconHandshake,
    headset: IconHeadset,
    key: IconKey,
    lightning: IconLightning,
    'list-checks': IconListChecks,
    'map-pin': IconMapPin,
    'map-trifold': IconMapTrifold,
    package: IconPackage,
    'paper-plane': IconPaperPlane,
    percent: IconPercent,
    phone: IconPhone,
    'phone-call': IconPhoneCall,
    'seal-check': IconSealCheck,
    'shield-check': IconShieldCheck,
    snowflake: IconSnowflake,
    sparkle: IconSparkle,
    'steering-wheel': IconSteeringWheel,
    storefront: IconStorefront,
    sun: IconSun,
    tag: IconTag,
    tire: IconTire,
    'users-three': IconUsersThree,
    'warning-circle': IconWarningCircle,
    wrench: IconWrench,

    // Social platforms (SOCIAL_ICON_OPTIONS) — simple-icons fill set
    instagram: IconInstagram,
    linkedin: IconLinkedin,
    x: IconX,
    facebook: IconFacebook,
    github: IconGithub,
    youtube: IconYoutube,
    tiktok: IconTiktok,
    pinterest: IconPinterest,
    whatsapp: IconWhatsapp,
    telegram: IconTelegram,
    mastodon: IconMastodon,
};

export type IconName = keyof typeof ICONS;

export function isIconName(value: unknown): value is IconName {
    return typeof value === 'string' && value in ICONS;
}
